import { Injectable } from '@angular/core';

/**
 * PosConfigOptionsService (Angular 18)
 *
 * Ported 1:1 from apps/b2b-ui/common/services/posConfig/posConfigOptions/posConfigOptions.service.js
 * (legacy name 'PosConfigOptionsService'). Holds the top-level POS config option
 * model. Internal sub-service of PosConfigService — injected directly, not
 * downgrade-registered. Dependency-free. Wave 3 #17.
 */
@Injectable({ providedIn: 'root' })
export class PosConfigOptionsService {
  model: any = {
    configId: '',
    name: '',
    description: '',
    orderListResultCountLimit: 50,
    apiTimeoutInSecs: 60,
    passcodes: [],
    cacheRefreshIntervalInSecs: 300,
    displayBrightnessPercent: 50,
  };

  init(): boolean {
    return true;
  }

  setModel(model: any): void {
    this.model = model ? model : {};
  }

  getModel(): any {
    return this.model;
  }

  hasPasscodes(): boolean {
    return this.model.passcodes instanceof Array && this.model.passcodes.length;
  }

  newPasscode(props: any): any {
    return {
      type: props.type,
      length: props.length,
      code: props.code,
    };
  }
}
